import { render, staticRenderFns } from "./goodCategoryList copy.vue?vue&type=template&id=dc4794a4&scoped=true"
import script from "./goodCategoryList copy.vue?vue&type=script&lang=js"
export * from "./goodCategoryList copy.vue?vue&type=script&lang=js"
import style0 from "./goodCategoryList copy.vue?vue&type=style&index=0&id=dc4794a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc4794a4",
  null
  
)

export default component.exports